
export interface ITravellerBasis{
    title: ETravellerTitle;
    lastName?: string;
    firstName?: string;
    xId?: string;
    gender?: ETravellerGender;
}

export interface ITravellerBasisPassport{
    number: string;
    issuance: {
        when: string;
        country: string;
    };
    validity: string;
}

export enum ETravellerTitle{
    Mr = "Mr",
    Ms = "Ms",
}

export enum ETravellerGender{
    Male = "Male",
    Female = "Female",
}
